import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgShielded = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.602 2.302a.75.75 0 0 0-1.186-.023c-.966 1.2-2.27 2.142-3.78 2.723a9.8 9.8 0 0 1-4.788.562.75.75 0 0 0-.848.744v3.958c.006 2.449.81 4.834 2.3 6.844 1.488 2.01 3.59 3.551 6.026 4.433h.002l.91.328.008.003a2.3 2.3 0 0 0 1.508 0l.009-.003.91-.328-.255-.706.256.706c2.436-.882 4.538-2.423 6.027-4.433s2.293-4.395 2.299-6.844V6.308a.75.75 0 0 0-.796-.749c-3.96.246-6.87-.928-8.602-3.257m.561 17.83-.903.325a.8.8 0 0 1-.52 0l-.903-.325c-2.172-.786-4.027-2.153-5.332-3.915-1.304-1.76-2-3.835-2.005-5.954V7.131a11.3 11.3 0 0 0 4.674-.729 10.6 10.6 0 0 0 3.806-2.498c2.001 2.193 4.948 3.247 8.52 3.184v3.174c-.005 2.12-.7 4.195-2.005 5.956s-3.16 3.128-5.332 3.914M17.02 9.908a.75.75 0 1 0-1.27-.797l-4.126 6.576-.02.007-1.7-2.275a.75.75 0 1 0-1.202.898l1.812 2.423a.8.8 0 0 0 .147.148 1.549 1.549 0 0 0 1.203.283c.205-.036.402-.113.579-.228.178-.116.332-.269.447-.452z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgShielded;
